import { getStyleProp } from './css-property-utils';
export var inlineFontSize = function (element, fallbacks) {
    var elementClasses = element.attr('class');
    if (elementClasses && elementClasses.includes('so-global')) {
        return element;
    }
    var fontSize = getStyleProp(element, 'font-size', fallbacks.css) || fallbacks.fontSize;
    return element.css('font-size', "".concat(parseInt(fontSize, 10), "px"));
};
//# sourceMappingURL=inline-font-size.js.map